import { Button, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import WhiteCard from "src/components/WhiteCard";
import { useGetPatientOrdersQuery } from "src/api/services/ordersApi";
import PatientOrder from "./components/PatientOrder";
import { usePatientOrdersModal } from "src/context/PatientOrdersModalProvider/usePatientOrdersModal";
import { useGetPatientDraftPrescriptionsQuery } from "src/api/services/prescriptionsApi";
import DraftPrescription from "./components/DraftPrescription/DraftPrescription";
import { PatientProfile } from "src/api/types";

interface Props {
  patient: PatientProfile;
  allowActions?: boolean;
}

const PatientOrders = ({ patient, allowActions = false }: Props) => {
  const { data } = useGetPatientOrdersQuery(patient.id);
  const { openCreateOrderModal } = usePatientOrdersModal();
  const { data: draftPrescriptions = [] } =
    useGetPatientDraftPrescriptionsQuery(patient.id);

  const orders = useMemo(() => {
    if (data == null) return [];
    return data.data;
  }, [data]);

  return (
    <WhiteCard
      width="320px"
      gap={1}
      sx={{ overflowY: "auto" }}
      maxHeight="600px"
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        gap={2}
        justifyContent={"space-between"}
      >
        <Typography variant="subtitle2">PATIENT ORDERS</Typography>
        {allowActions ? (
          <Button
            variant="text"
            sx={{ ml: "auto" }}
            onClick={() =>
              openCreateOrderModal({
                patientStripeId: patient.stripe_customer_id ?? "",
                patientId: patient.id,
                gender: patient.profile.gender,
              })
            }
          >
            {" "}
            + Create
          </Button>
        ) : null}
      </Stack>
      {draftPrescriptions.length > 0 ? (
        <Stack gap={2}>
          {draftPrescriptions.map((prescription) => (
            <DraftPrescription prescription={prescription} />
          ))}
        </Stack>
      ) : null}
      {orders.length > 0 ? (
        <Stack gap={2}>
          {orders.map((order) => (
            <PatientOrder key={order.id} order={order} />
          ))}
        </Stack>
      ) : (
        <Typography>Patient has no orders at this time.</Typography>
      )}
    </WhiteCard>
  );
};

export default PatientOrders;
